import React, { useCallback, useEffect, useRef, useState } from "react";
import { Badge, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Button, Progress } from "@/Components/ui";
;
import Select from "react-select";
import CommonDatePicker from "@/Components/Common/CommonDatePicker";
import { useNavigate } from "react-router-dom";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import toast, { Toaster } from 'react-hot-toast';
import { read, utils, writeFileXLSX, writeFile } from "xlsx";
import ServerPaginatedTable from "../../../Components/Common/ServerPaginatedTable";
import { BACKEND_HOST, API_RESERVATIONS, API_RESERVATION_ALL, changeReservationState, deleteReservationItem, getDataFromUrl, postData, refundReservationItem } from "../../../api";
import moment from "moment";
import QueryString from "qs";
import RefundModal from "../../../Components/Common/RefundModal";
import ReservationChangeModal from "../../../Components/ReservationChangeModal";
import DeleteOrRefundModal from "../../../Components/Common/DeleteOrRefundModal";
import { dialogService } from "@/utils/dialogService";
import { buildServerListUrl } from "@/utils/serverListQuery";
import {
    formatLinkedGroupReservationPayment,
    formatLinkedGroupReservationSummary,
    getGroupReservationStatusLabel,
    getLinkedGroupReservationSourceLabel,
} from "../GroupReservationRequests/groupReservationAdmin.mjs";
function printDiv(elid) {
    var divContents = document.getElementById(elid).innerHTML;
    var a = window.open("", "", "height=700, width=500");
    a.document.write("<html>");
    a.document.write('<body><table class="custom-header-css table">');
    a.document.write(divContents);
    // console.log(divContents)
    a.document.write("</table></body></html>");
    a.document.close();
    a.print();
}
const DailyReservationList = () => {
    const navigate = useNavigate();
    const refetchRef = useRef<() => void>(() => {});
    // const selectReservationState = [
    //     { label: "예약", value: "예약" }, // 구입후 기본 상태
    //     { label: "입장", value: "입장" }, // 예약날짜에 와서 입장한 상태
    //     { label: "외출", value: "외출" }, // 입장후 잠시 외출한 상태
    //     { label: "퇴장", value: "퇴장" },
    //     { label: "완료", value: "완료" }, // 사용 완료한 상태. 입장상태에서 날짜가 지나면 완료로 바꿈
    //     { label: "노쇼", value: "노쇼" }, // 예약날짜에 나타나지 않아서 환불도 불가한 상태
    // ]
    const [showChangeModal, setShowChangeModal] = useState(false);
    const columns = React.useMemo(() => [
        {
            Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()}/>,
            Cell: (cellProps) => {
                return <input type="checkbox" className="customerCheckBox form-check-input" value={cellProps.row.original.id}/>;
            },
            id: "#",
        },
        // {
        //   Header: "ID",
        //   accessor: "id",
        //   id: "id",
        // },
        {
            Header: "예약상품",
            accessor: "예약상품",
            id: "order",
            Cell: (cellProps) => {
                const groupReservation = cellProps.row.original["group_reservation"];
                return (<div>
              <div>{cellProps.row.original["예약상품"]}</div>
              <div className="text-muted">#{cellProps.row.original["id"]}</div>
              {groupReservation ? (<div className="mt-1">
                  <Badge color="info" className="me-1">단체예약</Badge>
                  <div className="text-muted small">{formatLinkedGroupReservationSummary(groupReservation)}</div>
                  <div className="text-muted small">
                    {getLinkedGroupReservationSourceLabel(groupReservation)} · {getGroupReservationStatusLabel(groupReservation.status)} · 입금 {formatLinkedGroupReservationPayment(groupReservation)}
                  </div>
                </div>) : null}
            </div>);
            },
        },
        {
            Header: "자리",
            accessor: "자리",
            id: "spot",
            Cell: (cellProps) => {
                const assignedSeat = cellProps.row.original["assigned_seat"];
                const spotLabel = String(cellProps.row.original["자리"] || "").startsWith("virtual") ? "자유석" : cellProps.row.original["자리"];
                return (<div>
              <div>{spotLabel}</div>
              {assignedSeat?.name ? <div className="text-success small">배정: {assignedSeat.name}</div> : null}
              <Button color="primary" size="sm" onClick={() => { setTargetCell(cellProps.row.original); setShowChangeModal(true); }}>
                자리변경
              </Button>
            </div>);
            }
        },
        {
            Header: "예약종료일",
            accessor: "예약종료일",
            id: "end_date",
        },
        {
            Header: "예약자",
            accessor: "예약자",
            id: "order__user__username",
            Cell: (cellProps) => {
                return (<div>
              <div>{cellProps.row.original["예약자"]}</div>
              <div>{cellProps.row.original["번호"]}</div>
            </div>);
            },
        },
        // {
        //     Header: '예약자',
        //     accessor: '예약자',
        //     id: 'order__user__username',
        // },
        // {
        //     Header: '번호',
        //     accessor: '번호',
        //     id: 'order__user__phone_num',
        // },
        {
            Header: "예약상태",
            accessor: "예약상태",
            id: "state",
            Cell: (cellProps) => {
                // const selref = useRef(null);
                // useEffect(() => {
                //     if (selref) {
                //         // selref.current.value = cellProps.row.original['예약상태']
                //         selref.current.setValue(selectReservationState.find((val) => {
                //             return cellProps.row.original['예약상태'].valueOf() === val.value.valueOf()
                //         }), "deselect-option")
                //     }
                // }, [cellProps, selref])
                // console.log(cellProps.row, cellProps.row.original['예약상태'])
                return (<>
              {/* <Select ref={selref}
                                  className="mb-0"
                                  defaultValue={selectReservationState.find((val) => {
                                      return cellProps.row.original['예약상태'].valueOf() === val.value.valueOf()
                                  })}
                                  onChange={(val) => {
                                      if (cellProps.row.original['예약상태'].valueOf() === val.value.valueOf()) return
                                      changeReservationState(cellProps.row.original.id, val.value).then((data) => {
                                          console.log("changeReservationState", data)
                                          toast.success(`예약상태를 변경하였습니다!\n : ${cellProps.row.original['예약자']} ${cellProps.row.original['예약상태']}=>${val.value}`, {
                                              position: "top-right",
                                              autoClose: 5000,
                                              hideProgressBar: false,
                                              closeOnClick: true,
                                              pauseOnHover: true,
                                              draggable: true,
                                              progress: undefined,
                                              theme: "light",
                                          });
                                      });
                                  }}
                                  options={selectReservationState}
                                  id={"choices-single-" + cellProps.row.original.id}
                              ></Select> */}

              <span>{cellProps.row.original["예약상태"]}</span>
              <span> </span>
              {["입장", "예약"].includes(cellProps.row.original["예약상태"]) ? (<Button color={cellProps.row.original["예약상태"] === "예약" ? "primary" : "danger"} size="sm" onClick={() => {
                            const _val = cellProps.row.original["예약상태"] === "예약" ? "입장" : "예약";
                            changeReservationState(cellProps.row.original.id, _val).then((data) => {
                                toast.success(`예약상태를 변경하였습니다!\n : ${cellProps.row.original["예약자"]} ${cellProps.row.original["예약상태"]}=>${_val}`, {
                                    position: "top-right",
                                    autoClose: 5000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                    theme: "light",
                                });
                                refetchRef.current();
                            });
                        }}>
                  {cellProps.row.original["예약상태"] === "예약" ? "입장하기" : "입장취소"}
                </Button>) : null}
              {["입장", "퇴장"].includes(cellProps.row.original["예약상태"]) ? (<>
                  <span> </span>
                  <Button color={cellProps.row.original["예약상태"] === "퇴장" ? "dark" : "info"} size="sm" onClick={() => {
                            const _val = cellProps.row.original["예약상태"] === "퇴장" ? "입장" : "퇴장";
                            changeReservationState(cellProps.row.original.id, _val).then((data) => {
                                toast.success(`예약상태를 변경하였습니다!\n : ${cellProps.row.original["예약자"]} ${cellProps.row.original["예약상태"]}=>${_val}`, {
                                    position: "top-right",
                                    autoClose: 5000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                    theme: "light",
                                });
                                refetchRef.current();
                            });
                        }}>
                    {cellProps.row.original["예약상태"] === "퇴장" ? "체크아웃취소" : "체크아웃"}
                  </Button>
                  <span> </span>
                </>) : null}

              {["외출", "퇴장", "완료"].includes(cellProps.row.original["예약상태"]) ? (<Button color={cellProps.row.original["예약상태"] === "퇴장" ? "secondary" : "danger"} size="sm" onClick={() => {
                            const _val = cellProps.row.original["예약상태"] === "퇴장" ? "완료" : "퇴장";
                            changeReservationState(cellProps.row.original.id, _val).then((data) => {
                                toast.success(`예약상태를 변경하였습니다!\n : ${cellProps.row.original["예약자"]} ${cellProps.row.original["예약상태"]}=>${_val}`, {
                                    position: "top-right",
                                    autoClose: 5000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                    theme: "light",
                                });
                                refetchRef.current();
                            });
                        }}>
                  {cellProps.row.original["예약상태"] === "퇴장" ? "완료처리" : "완료취소"}
                </Button>) : null}
            </>);
            },
        },
        {
            Header: "선물상태",
            accessor: "gifted",
            id: "",
            Cell: (cellProps) => {
                return <span>{cellProps.row.original["gifted"] ? "선물됨" : null}</span>;
            },
        },
        //   {
        //     Header: '결제상태',
        //     accessor: '결제상태',
        //     id: '',
        //   },
        {
            Header: "옵션",
            accessor: "Actions",
            id: "",
            Cell: (cellProps) => {
                return (<div className="d-flex flex-row justify-content-end align-items-end gap-2">
              {cellProps.row.original.options && cellProps.row.original.options.length ? (<div>
                  {cellProps.row.original.options.map((item) => {
                            if (item.type === "deposit")
                                return (<div key={item.id} style={{ textAlign: "right", marginBottom: "1px" }}>
                          <span>{item.name}</span>
                          <span> : </span>
                          <Button color="primary" size="sm" onClick={() => {
                                        setRefundModalData({
                                            id: item.id,
                                            name: item.name,
                                            price: item.price,
                                            type: item.type,
                                            state: item.state,
                                            reservId: cellProps.row.original.id,
                                        });
                                        setShowRefundModal(true);
                                    }}>
                            환불
                          </Button>
                        </div>);
                            return (<div key={item.id} style={{ textAlign: "right", marginBottom: "1px" }}>
                        <span>{item.name}</span>
                        <span> : </span>
                        {/* <span>{item.state}</span> */}
                        <Button color={item.state === "사용함" ? "danger" : "primary"} size="sm" onClick={() => {
                                    handleChangeReservOption(item.id, item.state === "사용함" ? "사용안함" : "사용함");
                                }}>
                          {item.state === "사용함" ? "사용취소" : "사용처리"}
                        </Button>
                        <span> </span>
                        <Button color="primary" size="sm" onClick={() => {
                                    setRefundModalData({
                                        id: item.id,
                                        name: item.name,
                                        price: item.price,
                                        type: item.type,
                                        state: item.state,
                                        reservId: cellProps.row.original.id,
                                    });
                                    setShowRefundModal(true);
                                }}>
                          환불
                        </Button>
                      </div>);
                        })}
                </div>) : // <div className="edit align-self-center"><Button size="sm" onClick={() => { setTargetCell(cellProps.row.original); setShowOptions(true) }}>옵션</Button></div>
                        null}


              <div className="remove align-self-center">
                <div className="text-danger" style={{ cursor: "pointer" }} onClick={() => {
                        onClickDelete(cellProps.row.original.id);
                    }}>
                  <i className="ri-delete-bin-5-fill fs-16"></i>
                </div>
              </div>
            </div>);
            },
        },
    ], []);
    const [packageProducts, setPackageProducts] = useState([]);
    useEffect(() => {
        getDataFromUrl(`${BACKEND_HOST}/package/items`).then((data) => {
            console.log("packageProducts", data);
            setPackageProducts(data);
        });
    }, []);
    const [targetDate, setTargetDate] = useState(new Date());
    const [data, setData] = React.useState([]);
    const [previous, setPrevious] = React.useState("");
    const [next, setNext] = React.useState("");
    const [count, setCount] = React.useState("");
    const defaultQuery = {
        sort: "state",
        order: "desc",
        date: moment(targetDate).format("YYYY-MM-DD"),
    };
    const [dataQuery, setDataQuery] = React.useState(defaultQuery);
    const onRequestData = (_url) => {
        getDataFromUrl(_url)
            .then((data) => {
            setData(data.results);
            setPrevious(data.previous);
            setNext(data.next);
            setCount(data.count);
            // if (isSearch) calcTotalPageCount(data.count, (data.results).length);
        })
            .catch((e) => {
            console.log(e);
        });
    };
    useEffect(() => {
        if (!previous && !next) {
            refetch();
        }
    }, []);
    useEffect(() => {
        refetch();
    }, [targetDate]);
    const refetch = useCallback(() => {
        const _date = moment(targetDate).format("YYYY-MM-DD");
        const _query = QueryString.stringify({
            ...dataQuery,
            date: _date,
        });
        console.log(_date, _query);
        // getDataFromUrl(`${API_RESERVATIONS}/?${QueryString.stringify(defaultQuery)}`)
        getDataFromUrl(buildServerListUrl(API_RESERVATIONS, {
            ...dataQuery,
            date: _date,
        }))
            .then((data) => {
            // console.log(data);
            setPrevious(data.previous);
            setNext(data.next);
            setCount(data.count);
            setData(data.results);
        })
            .catch((e) => {
            console.log(e);
        });
    }, [dataQuery, targetDate]);
    useEffect(() => {
        refetchRef.current = refetch;
    }, [refetch]);
    const [checkedRecords, setCheckedRecords] = React.useState([]);
    const [deleteModal, setDeleteModal] = React.useState(false);
    const [deleteModalMulti, setDeleteModalMulti] = React.useState(false);
    const checkedAll = () => {
        const checkall = document.getElementById("checkBoxAll");
        const ele = document.querySelectorAll(".customerCheckBox");
        if (checkall.checked) {
            ele.forEach((ele) => {
                ele.checked = true;
            });
        }
        else {
            ele.forEach((ele) => {
                ele.checked = false;
            });
        }
    };
    // const clearSelectedOptions = () => {
    //   const ele = document.querySelectorAll(".customerCheckBox:checked");
    //   const checkall = document.getElementById("checkBoxAll");
    //   ele.forEach((element) => {
    //     element.checked = false;
    //   })
    //   checkall.checked = false;
    //   // setFocusState(-1);
    // }
    // const changeCheckedRecords = () => {
    //   const ele = document.querySelectorAll(".customerCheckBox:checked");
    //   let checked = []
    //   try {
    //     ele.forEach((element) => {
    //       let tmpArr = data.filter((voucher) => (voucher.id).toString() === element.value.toString());
    //       let obj = tmpArr[0];
    //       checked.push(obj);
    //     })
    //   } catch (error) {
    //     console.log(error)
    //   }
    //   // console.log("changeCheckedRecords", checked)
    //   setCheckedRecords(checked);
    // }
    const deleteRecords = async () => {
        const ele = document.querySelectorAll(".customerCheckBox:checked");
        const checkall = document.getElementById("checkBoxAll");
        if (ele.length === 0) {
            await dialogService.handleAlert("삭제할 항목이 없습니다.");
            return;
        }
        ele.forEach((element) => {
            console.log("reservation id:", element.value);
            deleteReservationItem(element.value)
                .then((data) => {
                console.log("deleteReservationItem:", data);
            })
                .catch((e) => {
                console.warn(e);
            });
            element.checked = false;
        });
    };
    const onClickDelete = (order) => {
        setCheckedRecords([order]);
        setDeleteModal(true);
    };
    const handleDeleteOrder = (cancelAmtount = 0) => {
        if (checkedRecords.length) {
            checkedRecords.forEach((value) => {
                console.log("reservation id:", value);
                deleteReservationItem(value, cancelAmtount)
                    .then(async (data) => {
                    console.log("deleteReservationItem:", data);
                    if (data.error) {
                        await dialogService.handleAlert("요청실패:" + data.error);
                        return;
                    }
                    refetch();
                })
                    .catch(async (e) => {
                    await dialogService.handleAlert("항목 삭제 실패했습니다!", { force: "error" });
                    console.warn(e);
                });
            });
            setDeleteModal(false);
        }
    };
    const handleRefundOrder = (cancelAmtount = 0) => {
        if (checkedRecords.length) {
            checkedRecords.forEach((value) => {
                console.log("reservation id:", value);
                refundReservationItem(value, cancelAmtount)
                    .then(async (data) => {
                    console.log("refundReservationItem:", data);
                    if (data.error) {
                        await dialogService.handleAlert("요청실패:" + data.error);
                        return;
                    }
                    toast.success(data.message, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    refetch();
                })
                    .catch(async (e) => {
                    await dialogService.handleAlert("항목 삭제 실패했습니다!", { force: "error" });
                    console.warn(e);
                });
            });
            setDeleteModal(false);
        }
    };
    const [showOptions, setShowOptions] = useState(false);
    const toggleShowOptions = () => {
        setShowOptions(!showOptions);
    };
    const [targetCell, setTargetCell] = useState(null);
    const handleChangeReservOption = (id, state) => {
        postData(`${BACKEND_HOST}/package/change-reservation-option/${id}/`, { state }, "PUT")
            .then((data) => {
            console.log("reservation option updated", data);
            refetchRef.current();
        })
            .catch((e) => console.log("Error while update reservation option...", e));
    };
    const [showRefundModal, setShowRefundModal] = useState(false);
    const [refundModalData, setRefundModalData] = useState(null);
    const handleRefundReservOption = async (option_id, reserv_id, is_complete) => {
        const data = await postData(`${BACKEND_HOST}/package/cancel-reservation-options/`, {
            reserv_options: [{ id: option_id }],
        }, "POST");
        console.log("reservation option refunded", data);
        if (is_complete) {
            const result = await changeReservationState(reserv_id, "완료");
            console.log("reservation state changed", result);
        }
        refetch();
    };
    return (<div className="page-content">

      <ReservationChangeModal visible={showChangeModal} toggle={() => setShowChangeModal(!showChangeModal)} targetData={targetCell} refreshPage={refetch}/>

      <DeleteOrRefundModal show={deleteModal} onDeleteClick={handleDeleteOrder} onCloseClick={() => setDeleteModal(false)} onRefundClick={handleRefundOrder} itemPrice={checkedRecords[0] && data.find((item) => item.id === checkedRecords[0]) ? data.find((item) => item.id === checkedRecords[0])["결제금액"] : 0} packageRefundAmount={checkedRecords[0] && data.find((item) => item.id === checkedRecords[0]) ? data.find((item) => item.id === checkedRecords[0])["패키지환불금액"] : 0} totalRefundAmount={checkedRecords[0] && data.find((item) => item.id === checkedRecords[0]) ? data.find((item) => item.id === checkedRecords[0])["환불예상금액"] : 0}/>
      {/* <DeleteModal show={deleteModal} onDeleteClick={handleDeleteOrder} onCloseClick={() => setDeleteModal(false)} /> */}
      <DeleteModal show={deleteModalMulti} onDeleteClick={() => {
            deleteRecords();
            setDeleteModalMulti(false);
        }} onCloseClick={() => setDeleteModalMulti(false)}/>

      <Modal isOpen={showOptions} onClose={toggleShowOptions} centered={true}>
        <ModalBody className="py-3 px-5">
          <div className="mt-2 text-left">
            <div className="mt-4 pt-2 fs-15 mx-sm-5">
              <h4>예약상세</h4>
              {targetCell && (<div className="mt-4">
                  <p className="text-muted mb-0">예약상품: {targetCell["예약상품"]}</p>
                  <p className="text-muted mb-0">자리: {targetCell["자리"]}</p>
                  <p className="text-muted mb-0">예약자: {targetCell["예약자"]}</p>
                  <p className="text-muted mb-0">예약시작일: {targetCell["예약시작일"]}</p>
                  <p className="text-muted mb-0">예약종료일: {targetCell["예약종료일"]}</p>
                  <p className="text-muted mb-0">예약상태: {targetCell["예약상태"]}</p>
                  <p className="text-muted mb-0">결제금액: {targetCell["결제금액"]}</p>
                  {targetCell["gifted"] && <p className="text-muted mb-0">선물상태: {targetCell["gifted"]}</p>}
                  <div className="text-muted mt-2">
                    옵션:{" "}
                    {targetCell.options.map((item, idx) => {
                return (<p className="text-muted mx-4 mb-0" key={idx}>
                          <span>{item.name} - </span>
                          <span>{item.price}원</span>
                        </p>);
            })}
                  </div>
                </div>)}
            </div>
          </div>
          <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
            <Button type="button" data-bs-dismiss="modal" onClick={() => {
            setShowOptions(false);
        }} color="light">
              Close
            </Button>
          </div>
        </ModalBody>
      </Modal>

      <Container fluid>
        <BreadCrumb title="예약관리" pageTitle="예약"/>
        <Row>
          <Col lg={12}>
            <PackagesStatus packages={packageProducts} targetDate={targetDate}/>
          </Col>
          <Col lg={12}>
            <Card id="orderList">
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">예약 목록</h5>
                  <div className="flex-shrink-0">
                    <Button color="success" className="add-btn me-1" onClick={() => {
            navigate("/reservation-add-item/");
        }} id="create-btn">
                      새 예약 추가
                    </Button>
                    <Button onClick={async () => {
            await dialogService.handleAlert("액셀 파일을 다운로드합니다... 건수가 400건이 넘을 경우 파일에 누락될 수 있으니 유의하시기 바랍니다.");
            getDataFromUrl(`${API_RESERVATION_ALL}/?${QueryString.stringify(dataQuery)}`).then((data) => {
                // const rows = data.map(row => ({
                // // id	예약신청일	예약상품	자리	예약자	번호	예약시작일	이용기간	예약상태	결제상태	승인번호
                // }));
                const worksheet = utils.json_to_sheet(data);
                const workbook = utils.book_new();
                utils.book_append_sheet(workbook, worksheet, "id");
                writeFileXLSX(workbook, "output.xlsx");
            });
            // const worksheet = utils.table_to_sheet(document.getElementById('reservations-table'))
            // const workbook = utils.book_new()
            // utils.book_append_sheet(workbook, worksheet)
            // writeFileXLSX(workbook, "output.xlsx")
            // writeFile(workbook, "output.csv")
        }} color="soft">
                      <i className="ri-save-2-line"></i>
                    </Button>
                    <span style={{ padding: "4px" }}></span>
                    <Button onClick={() => {
            printDiv("reservations-table");
        }} color="soft">
                      <i className="ri-printer-line"></i>
                    </Button>
                    <span style={{ padding: "4px" }}></span>
                    <Button onClick={() => setDeleteModalMulti(true)} color="soft-danger">
                      <i className="ri-delete-bin-2-line"></i>
                    </Button>
                  </div>
                </div>
              </CardHeader>

              <CardBody className="pt-0">
                <Col md={4}>
                  <div className="mb-3">
                    <Label htmlFor="date-field" className="form-label">
                      예약날짜
                    </Label>
                    <CommonDatePicker id="date-field" className="form-control" size={"32px"} options={{
        }} placeholder="Select Date" value={targetDate} onChange={(value) => {
            setTargetDate(value[0]);
            setDataQuery({
                ...defaultQuery,
                date: moment(value[0]).format("YYYY-MM-DD"),
            });
        }}/>
                  </div>
                </Col>

                <div className="card-body pt-0 px-2">
                  <div>
                    <React.Fragment>
                      <ServerPaginatedTable id="reservations-table" url={API_RESERVATIONS} columns={columns} data={data} previous={previous} next={next} count={count} onRequestData={onRequestData} tableQuery={dataQuery} onChangeQuery={setDataQuery} categories={[
            { id: 0, title: "전체", state: "", icon: "ri-store-2-fill" },
            ...packageProducts.filter((item) => item && item["상태"].valueOf() === "노출중").map((item, idx) => ({ id: idx + 1, title: item["상품명"], search: item["상품명"], icon: "ri-store-2-fill" })),
        ]}/>
                    </React.Fragment>
                  </div>
                </div>

                <Toaster position="top-center"/>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      <RefundModal show={showRefundModal} onCloseClick={() => setShowRefundModal(false)} data={refundModalData} onRefundClick={() => {
            if (refundModalData) {
                const { id, reservId } = refundModalData;
                handleRefundReservOption(id, reservId, false).then(() => {
                    setShowRefundModal(false);
                });
            }
        }} onRefundCompleteClick={() => {
            if (refundModalData) {
                const { id, reservId } = refundModalData;
                handleRefundReservOption(id, reservId, true).then(() => {
                    setShowRefundModal(false);
                });
            }
        }}/>
    </div>);
};
export default DailyReservationList;
const PackagesStatus = ({ packages, targetDate }) => {
    const [hide, setHide] = useState(true);
    // const [reservCount, setReservCount] = useState(0)
    // const [checkInCount, setCheckInCount] = useState(0)
    const [PackageStatus, setPackageStatus] = useState(packages);
    const abortRef = useRef(null);
    useEffect(() => {
        if (abortRef.current)
            abortRef.current.abort();
        const date = moment(targetDate).format("YYYY-MM-DD");
        const query = {
            date: date,
        };
        abortRef.current = new AbortController();
        getDataFromUrl(`${API_RESERVATION_ALL}/?${QueryString.stringify(query)}`, abortRef.current.signal)
            .then((data) => {
            setPackageStatus(packages.map((item) => {
                const reservCount = data.filter((reserv) => reserv["예약상품"] === item["상품명"]).length;
                const checkInCount = data.filter((reserv) => reserv["예약상품"] === item["상품명"] && reserv["예약상태"] !== "예약").length;
                return {
                    ...item,
                    reservCount: reservCount,
                    checkInCount: checkInCount,
                };
            }));
        })
            .catch((error) => {
            console.log(error);
        });
    }, [packages, targetDate]);
    return (<Card id="packages-status" style={{ marginBottom: "10px" }}>
      <CardHeader className="card-header border-0">
        <div className="d-flex align-items-center">
          <h5 className="card-title mb-0 flex-grow-1">패키지 상태</h5>
          <div className="flex-shrink-0">
            <Button color="ghost" className="text-muted btn-sm" style={{ fontSize: "14px" }} onClick={() => setHide(!hide)}>
              {hide ? <i className="ri-arrow-down-s-line"></i> : <i className="ri-arrow-up-s-line"></i>}
              {hide ? "열기" : "접기"}
            </Button>
          </div>
        </div>
      </CardHeader>
      {!hide ? (<CardBody className="pt-0">
          {PackageStatus.map((item, idx) => {
                return (<div className="d-flex align-items-center" key={idx} style={{ marginBottom: "10px" }}>
                <div className="flex-grow-1">
                  <h5 className="font-size-14 mb-1" style={{ fontSize: "14px" }}>
                    {item["상품명"]}
                  </h5>
                  <div className="d-flex align-items-center">
                    <div className="flex-1">
                      <Progress value={item.reservCount} max={item["자리수"]} color="primary"/>
                    </div>
                    <div className="flex-1 ms-2">
                      <span className="text-muted">
                        예약 {item.reservCount} : 잔여 {item["자리수"] - item.reservCount} (좌석 {item["자리수"]})
                      </span>
                    </div>
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="flex-1">
                      <Progress value={item.checkInCount} max={item.reservCount} color="primary"/>
                    </div>
                    <div className="flex-1 ms-2">
                      <span className="text-muted">
                        입장완료 {item.checkInCount} : 미입장 {item.reservCount - item.checkInCount}
                      </span>
                    </div>
                  </div>
                </div>
              </div>);
            })}
        </CardBody>) : null}
    </Card>);
};
